import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-DuplicateShape",
  "use": "svg-icon-DuplicateShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-DuplicateShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.25 0H0v8.25h8.25V0zm-1.5 1.5H1.5v5.25h5.25V1.5z\" fill=\"#000\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.75 9v3H12V3.75H9v1.5h1.5v5.25H5.25V9h-1.5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol